export const empty = (mixed_var) => {
    return (mixed_var === "" || mixed_var === 0   || mixed_var === "0" || mixed_var === null  ||mixed_var === undefined  || mixed_var === false  ||  ( Array.isArray(mixed_var) && mixed_var.length === 0 ) );
};
